import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { StaticDataContextWrapper } from "../../shared/src/context/StaticDataContext";
import { platformState } from "../../shared/src/states/uiStates";
import { App } from "./App";
import "./index.css";

import * as Sentry from "@sentry/react";

Sentry.init({
	dsn: import.meta.env.VITE_BUGSINK_DSN,
	release: "lolplanner-client@w-" + APP_VERSION,
	integrations: [],
	tracesSampleRate: 0,
	sendDefaultPii: false,
});

const root = createRoot(document.querySelector("#root")!, {
	onCaughtError: Sentry.reactErrorHandler(),
	onRecoverableError: Sentry.reactErrorHandler(),
});

platformState.platform = "web";

root.render(
	<StaticDataContextWrapper>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</StaticDataContextWrapper>,
);
